var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.60205 9.14844L1.85205 5.39844C1.74638 5.29276 1.68701 5.14944 1.68701 5C1.68701 4.85056 1.74638 4.70723 1.85205 4.60156C1.95772 4.49589 2.10105 4.43652 2.25049 4.43652C2.39993 4.43652 2.54325 4.49589 2.64893 4.60156L6.00002 7.95359L9.35205 4.6025C9.40438 4.55018 9.46649 4.50867 9.53486 4.48035C9.60322 4.45204 9.67649 4.43746 9.75049 4.43746C9.82449 4.43746 9.89776 4.45204 9.96612 4.48035C10.0345 4.50867 10.0966 4.55018 10.1489 4.6025C10.2013 4.65482 10.2428 4.71694 10.2711 4.7853C10.2994 4.85367 10.314 4.92694 10.314 5.00094C10.314 5.07493 10.2994 5.14821 10.2711 5.21657C10.2428 5.28493 10.2013 5.34705 10.1489 5.39937L6.39893 9.14937C6.34661 9.20175 6.28446 9.24329 6.21606 9.2716C6.14765 9.29991 6.07433 9.31444 6.00029 9.31435C5.92626 9.31426 5.85297 9.29956 5.78463 9.27109C5.7163 9.24262 5.65425 9.20094 5.60205 9.14844Z",
  fill: "#7A757F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_arrow.4ce9e8f1e988f030cb8ffd48ae380782.svg";